/**
 * Banner discreto para instalar o app candidato (PWA Fase 1).
 */
import React, { useEffect, useState } from 'react';
import { apiClient } from '../../api/apiClient';
import { isIosSafari, useCandidatePwaInstall } from '../../pwa/candidatePwa';
import { applyTenantPwaFromConfig } from '../../pwa/tenantPwaContract';

export function CandidatePwaInstallBanner({ institutionLabel = '' }) {
  const [resolvedLabel, setResolvedLabel] = useState((institutionLabel || '').trim());
  const { showBanner, install, dismiss } = useCandidatePwaInstall();
  const [busy, setBusy] = useState(false);
  const [showManualHint, setShowManualHint] = useState(false);

  useEffect(() => {
    let cancelled = false;
    apiClient.getConfig()
      .then((d) => {
        if (cancelled) return;
        applyTenantPwaFromConfig(d);
        const label = (institutionLabel || d?.institution_name || '').trim();
        if (label) setResolvedLabel(label);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [institutionLabel]);

  if (!showBanner) return null;

  const label = resolvedLabel;
  const title = label ? `App Ingressa — ${label}` : 'App Ingressa para candidatos';

  const onInstall = async () => {
    setBusy(true);
    try {
      const result = await install();
      if (!result.ok) {
        setShowManualHint(true);
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        marginBottom: 16,
        padding: '12px 14px',
        borderRadius: 8,
        border: '1px solid #BFDBFE',
        backgroundColor: '#EFF6FF',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'flex-start' }}>
        <div style={{ fontSize: 14, color: '#1E3A8A', fontWeight: 600 }}>📲 {title}</div>
        <button
          type="button"
          onClick={dismiss}
          aria-label="Fechar"
          style={{
            border: 'none',
            background: 'transparent',
            color: '#6B7280',
            cursor: 'pointer',
            fontSize: 18,
            lineHeight: 1,
            padding: 0,
          }}
        >
          ×
        </button>
      </div>

      <p style={{ margin: 0, fontSize: 13, color: '#374151' }}>
        Instale na tela inicial do celular para acompanhar inscrições com mais praticidade.
      </p>
      <button
        type="button"
        disabled={busy}
        onClick={onInstall}
        style={{
          alignSelf: 'flex-start',
          padding: '8px 14px',
          borderRadius: 6,
          border: 'none',
          backgroundColor: '#1E3A8A',
          color: '#fff',
          fontSize: 14,
          fontWeight: 600,
          cursor: busy ? 'wait' : 'pointer',
          opacity: busy ? 0.8 : 1,
        }}
      >
        {busy ? 'Abrindo…' : 'Instalar aplicativo'}
      </button>

      {showManualHint && (
        <p style={{ margin: 0, fontSize: 13, color: '#374151' }}>
          {isIosSafari() ? (
            <>
              No iPhone: toque em <strong>Compartilhar</strong> no Safari e escolha{' '}
              <strong>Adicionar à Tela de Início</strong>.
            </>
          ) : (
            <>
              No Samsung, use o <strong>Chrome</strong> (não o “Internet” da Samsung). Menu →{' '}
              <strong>Instalar app</strong> ou <strong>Adicionar à tela inicial</strong>.
            </>
          )}
        </p>
      )}
    </div>
  );
}
